import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RadioButtonGroup } from "../../../../../RadioButton/RadioButtonGroup";
import { setDueDay } from "../../../../store/donation/actions";
import { State } from "../../../../store/state";
import { Pane, PaneContainer, PaneTitle } from "../../Panes.style";
import { DateText } from "../Vipps/VippsDatePicker/VippsDatePicker.style";
import { AvtaleGiroDatePicker } from "./AvtaleGiroDatePicker/AvtaleGiroDatePicker";
import { formatChargeDay, getEarliestPossibleChargeDate } from "./AvtaleGiroDatePicker/avtalegirodates";
import { RecurringBankDonationForm } from "./RecurringForm";
import { Referrals } from "../../../shared/Referrals/Referrals";
import { AvtaleGiroPaymentMethod, WidgetPane3ReferralsProps } from "../../../../types/WidgetProps";
import { Dispatch } from "@reduxjs/toolkit";
import { DonationActionTypes } from "../../../../store/donation/types";
export const AvtaleGiroPane: React.FC<{
  config: AvtaleGiroPaymentMethod;
  referrals: WidgetPane3ReferralsProps;
}> = t0 => {
  const $ = _c(43);
  const {
    config,
    referrals
  } = t0;
  const donation = useSelector(_temp);
  const [chooseChargeDay, setChooseChargeDay] = useState(0);
  const dispatch = useDispatch();
  let t1;
  if ($[0] !== chooseChargeDay || $[1] !== dispatch) {
    t1 = () => {
      if (chooseChargeDay === 0) {
        dispatch(setDueDay(getEarliestPossibleChargeDate()));
      }
    };
    $[0] = chooseChargeDay;
    $[1] = dispatch;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== chooseChargeDay) {
    t2 = [chooseChargeDay];
    $[3] = chooseChargeDay;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== config.title) {
    t3 = <PaneTitle>{config.title}</PaneTitle>;
    $[5] = config.title;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      paddingTop: 20
    };
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== config.selector_earliest_text) {
    t5 = {
      title: config.selector_earliest_text,
      value: 0
    };
    $[8] = config.selector_earliest_text;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== config.selector_choose_date_text) {
    t6 = {
      title: config.selector_choose_date_text,
      value: 1
    };
    $[10] = config.selector_choose_date_text;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = [t5, t6];
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = option => setChooseChargeDay(option);
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== chooseChargeDay || $[17] !== t7) {
    t9 = <div style={t4}><RadioButtonGroup options={t7} selected={chooseChargeDay} onSelect={t8} /></div>;
    $[16] = chooseChargeDay;
    $[17] = t7;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      paddingTop: 40
    };
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== chooseChargeDay) {
    t11 = chooseChargeDay === 0 && <DateText>{formatChargeDay(getEarliestPossibleChargeDate())}</DateText>;
    $[20] = chooseChargeDay;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== chooseChargeDay || $[23] !== config.date_selector_configuration) {
    t12 = chooseChargeDay === 1 && <AvtaleGiroDatePicker configuration={config.date_selector_configuration} />;
    $[22] = chooseChargeDay;
    $[23] = config.date_selector_configuration;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t11 || $[26] !== t12) {
    t13 = <div style={t10}>{t11}{t12}</div>;
    $[25] = t11;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t13 || $[29] !== t3 || $[30] !== t9) {
    t14 = <div>{t3}{t9}{t13}</div>;
    $[28] = t13;
    $[29] = t3;
    $[30] = t9;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== config.button_text || $[33] !== donation) {
    t15 = <div><RecurringBankDonationForm donation={donation} buttonText={config.button_text} /></div>;
    $[32] = config.button_text;
    $[33] = donation;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== referrals.other_referral_input_placeholder || $[36] !== referrals.referrals_title || $[37] !== referrals.show_referrals) {
    t16 = !(referrals.show_referrals === false) && <Referrals text={{
      referrals_title: referrals.referrals_title,
      other_referral_input_placeholder: referrals.other_referral_input_placeholder
    }} />;
    $[35] = referrals.other_referral_input_placeholder;
    $[36] = referrals.referrals_title;
    $[37] = referrals.show_referrals;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== t14 || $[40] !== t15 || $[41] !== t16) {
    t17 = <Pane><PaneContainer>{t14}{t15}{t16}</PaneContainer></Pane>;
    $[39] = t14;
    $[40] = t15;
    $[41] = t16;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  return t17;
};
function _temp(state) {
  return state.donation;
}